import { useCallback } from "react";
import { extractErrorMessage } from "../utils/errors";
import { useToast } from "../components/Toast";

export const useRequestError = () => {
  const { showToast } = useToast();

  const handleRequestError = useCallback(
    (error: unknown) => {
      const message = extractErrorMessage(error);
      if (!message) {
        return;
      }
      showToast({ type: "error", title: "Error", message });
    },
    [showToast]
  );

  return { handleRequestError };
};
